// extracted by mini-css-extract-plugin
export default {"button":"SnsButton_button__FGBfv"};